import React from 'react';
import { Typography } from '../../../visual-components/typography/typography';
import { useFormatter } from '../../../core/formatter/use-formatter';
import { notNil } from '../../../core/helpers/is-nil';

type Props = {
  amount?: number;
};

export const TotalAmount: React.FC<Props> = ({ amount }) => {
  const { formatCurrency } = useFormatter();

  return notNil(amount) ? (
    <Typography fontStyle="bold" variant="maintext">
      {formatCurrency(amount / 100)}
    </Typography>
  ) : null;
};
